import * as ACTION from '../constants';

const INITIAL_STATE = {
  error: null,
  loading: false,
  data: {},
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case ACTION.SEND_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data || {},
        error: null,
      };
    case ACTION.SEND_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
